import * as React from "react";
import { formatMessage } from "lib/globalize-util";
import { ConfirmDialog } from "components/dialog";
import { DATATEST } from "constants/integration";

interface IProps {
    open: boolean;
    onConfirm: () => void;
    onClose: () => void;
}

export const MarketSettingsConfirmationModal = ({ open, onConfirm, onClose }: IProps) => {
    const styles = {
        maxWidth: "460px",
        textAlign: "center",
    };
    return (
        <ConfirmDialog
            open={open}
            onConfirm={onConfirm}
            onCancel={onClose}
            onRequestClose={onClose}
            contentStyle={styles}
            title={formatMessage("Close window")}
            cancelLabel={formatMessage("Go back")}
            confirmLabel={formatMessage("Yes, discard changes")}
            dataTestConfirm={DATATEST.FOLDERS.DIALOG.OK_BTN}
            dataTestCancel={DATATEST.FOLDERS.DIALOG.CANCEL_BTN}
        >
            {formatMessage("Are you sure? Any changes will not be saved.")}
        </ConfirmDialog>
    );
};
